import { AlexiRoutes } from '../../utils/constants/AlexiRoutes.enum'
import { PageDataProvider } from './core'
import { useHistory, useLocation } from 'react-router-dom'

const MasterLayout: React.FC = ({ children }) => {
  const history = useHistory()
  const location = useLocation()

  // Extract the path without the leading slash
  const currentPath = location.pathname.split('/')[1]

  // Check if current path is not in AlexiRoutes
  const isInvalidRoute =
    currentPath &&
    !Object.values(AlexiRoutes).includes(currentPath as AlexiRoutes) &&
    currentPath !== 'application' &&
    currentPath !== 'error'

  if (isInvalidRoute) {
    history.push('/application/type')
  }

  return (
    <PageDataProvider>
      {/* <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <Toolbar />
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>{children}</Content>
            </div>
          </div>
          <Footer />
        </div>
      </div> */}

      {/* begin:: Drawers */}
      {/* <ActivityDrawer />
      <ExploreMain />
      <DrawerMessenger /> */}
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      {/* <Main />
      <InviteUsers />
      <UpgradePlan /> */}
      {/* end:: Modals */}
      {/* <ScrollTop /> */}
    </PageDataProvider>
  )
}

export { MasterLayout }
